import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Handle chunk load failures by forcing a full reload (once)
window.addEventListener('error', (event) => {
  if (event.message && (event.message.includes('Loading chunk') || event.message.includes('ChunkLoadError'))) {
    const lastReload = sessionStorage.getItem('ibn_chunk_reload');
    if (!lastReload || Date.now() - parseInt(lastReload) > 30000) {
      sessionStorage.setItem('ibn_chunk_reload', Date.now().toString());
      window.location.reload(true);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
